export default __webpack_public_path__ + "static/media/footer-bg.65bf81a4.png";